<div class="docs-section" id="pricing-and-limits">
  <div class="docs-section__head">
    <h1 class="docs-h1">Pricing &amp; limits</h1>
    <p class="docs-subtitle">
      Billing is prepaid: an organization holds a balance and each call spends from it.
    </p>
  </div>

  <!-- The price, first and largest: it's what this page is opened for. -->
  <section class="docs-price" aria-label="Price per call">
    <span class="docs-price__label">Every call</span>
    <p class="docs-price__value">1 <span class="docs-price__unit">credit</span></p>
    <p class="docs-price__note">Flat, regardless of which parameters you send.</p>
    <ul class="docs-price__endpoints" aria-label="Endpoints at this price">
      <li>rag</li>
      <li>answer</li>
      <li>search</li>
      <li>image</li>
      <li>similar</li>
    </ul>
    <p class="docs-price__formula">
      A call costs its <code class="docs-param">credits</code> &times; <code class="docs-param">price per credit</code>.
    </p>
  </section>

  <ul class="docs-facts">
    <li class="docs-facts__item">
      <span class="docs-facts__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>
          <path d="M21 9h-6a3 3 0 0 0 0 6h6z"/>
        </svg>
      </span>
      <div class="docs-facts__text">
        <p class="docs-facts__title">Prepaid balance</p>
        <p class="docs-facts__desc">Top up your wallet. Calls are authorized against the balance.</p>
      </div>
    </li>
    <li class="docs-facts__item">
      <span class="docs-facts__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z"/>
        </svg>
      </span>
      <div class="docs-facts__text">
        <p class="docs-facts__title">No monthly limits</p>
        <p class="docs-facts__desc">Use what you need. You only pay for what you call.</p>
      </div>
    </li>
    <li class="docs-facts__item">
      <span class="docs-facts__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="13" r="8"/>
          <path d="M12 9v4l2 2M9 2h6"/>
        </svg>
      </span>
      <div class="docs-facts__text">
        <p class="docs-facts__title">60 requests per minute, per API key</p>
        <p class="docs-facts__desc">
          Going over returns <code class="docs-param">429</code> before the request is routed, with a
          <code class="docs-param">Retry-After</code> hint in the error <code class="docs-param">details</code>. See
          <a class="link" routerLink="/docs/errors">Errors</a> for the full envelope.
        </p>
      </div>
    </li>
  </ul>

  <span class="docs-ep-group__label">Good to know</span>

  <div class="docs-note">
    <span class="docs-note__icon" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>
        <path d="m9 12 2 2 4-4"/>
      </svg>
    </span>
    <div class="docs-note__text">
      <p class="docs-note__title">An upstream fault is not charged</p>
      <p class="docs-note__desc">
        A 5xx from the index is recorded in your usage but costs nothing, since the failure is not yours to pay for.
        Metering happens after the response is sent, so bookkeeping never slows a call down.
      </p>
    </div>
  </div>

  <div class="docs-note docs-note--warn">
    <span class="docs-note__icon" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/>
        <path d="M12 9v4M12 17h.01"/>
      </svg>
    </span>
    <div class="docs-note__text">
      <p class="docs-note__title">A balance may go slightly negative</p>
      <p class="docs-note__desc">
        Debiting happens after a response is sent, so under heavy concurrency a few calls can land past zero: a
        request already served is a debt rather than something to round away. The next call is refused until you
        top up.
      </p>
    </div>
  </div>
</div>
